import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry"

import PagingControler from "../../../../../../../src-js/Fratello/Common/Controllers/PagingController";

export default function Footer({ sorting, sort, paging, labels, onSort, onChangePage }) {
    const Choice = ComponentRegistry.get("Choice");

    return (
      <footer className="row-paging">
        <div className="row clearfix">
          <div className="col-xs-12 col-sm-6 paging">
            <PagingControler {...paging} labels={labels}  onChange={onChangePage} />
          </div>
          <div className="col-sm-6 hidden-xs-down">
            <div className="pagination text-muted text-upper text-right">{labels.total_results.replace("{items}", typeof paging.items !== "undefined" ? paging.items.total : null)}</div>
          </div>
        </div>
      </footer>
    );
}

Footer.propTypes = {
    sorting: PropTypes.shape({}),
    sort: PropTypes.string,
    paging: PropTypes.shape({}),
    labels: PropTypes.shape({
        total_results: PropTypes.string.isRequired,
    }),
    onSort: PropTypes.func.isRequired,
    onChangePage: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Atoms/Footer.jsx